import moment from 'moment-timezone';

export const getFormattedDate = (date: string) => moment(date).format('MMM DD');
